import styled from 'styled-components';
export var Strong = styled.strong.withConfig({
  displayName: "Strong",
  componentId: "sc-1koynoc-0"
})(["font-weight:600;"]);